import { api } from '../../services'
import {
  UPLOAD_ACCEPTED_FILES_ADD,
  UPLOAD_ACCEPTED_FILE_REMOVE,
  UPLOAD_CLEAR,
  UPLOAD_UPLOADED_FILES_ADD,
  UPLOAD_UPLOADED_FILES_REMOVE,
  UPLOAD_TABLE_UPDATE_BY_ID,
  UPLOAD_TABLE_UPDATE,
  UPLOAD_TABLE_REFRESH,
  UPLOAD_DEFAULTS,
  UPLOAD_TABLE_REFRESH_FILE_TAG
} from '../types'
import { message } from 'antd'

function addUploadedFile (file) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_UPLOADED_FILES_ADD,
      payload: file
    })
  }
}

function removeUploadedFile (guid) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_UPLOADED_FILES_REMOVE,
      payload: guid
    })
  }
}
function addAcceptedFiles (files) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_ACCEPTED_FILES_ADD,
      payload: files
    })
  }
}

function removeAccpetedFile (key) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_ACCEPTED_FILE_REMOVE,
      payload: key
    })
  }
}

function uploadFile (file, callback) {
  return (dispatch) => {
    return api.storage.upload(file, callback)
      .then(response => {
        if (response.data.result !== null) {
          dispatch(removeAccpetedFile(file.name))
          dispatch(addUploadedFile(response.data.result))
        } else {
          console.log('error')
        }
        return response
      })
      .catch(() => {
        message.error('File upload error.')
      })
  }
}

function clearUpload (id) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_CLEAR
    })
  }
}

function updateUploadedTableById (id) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_TABLE_UPDATE_BY_ID,
      payload: id
    })
  }
}

function updateUploadedTable (key) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_TABLE_UPDATE,
      payload: key
    })
  }
}

function refreshUploadedTable () {
  return (dispatch, getState) => {
    dispatch({
      type: UPLOAD_TABLE_REFRESH,
      payload: getState().storage.data.files
    })
  }
}

function setUploadedDefaults () {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_DEFAULTS
    })
  }
}

function uploadedFileHandleTag (guid, data) {
  return (dispatch) => {
    dispatch({
      type: UPLOAD_TABLE_REFRESH_FILE_TAG,
      payload: {
        guid,
        data
      }
    })
  }
}

export {
  addAcceptedFiles,
  removeAccpetedFile,
  clearUpload,
  uploadFile,
  addUploadedFile,
  removeUploadedFile,
  updateUploadedTableById,
  updateUploadedTable,
  refreshUploadedTable,
  setUploadedDefaults,
  uploadedFileHandleTag
}



// WEBPACK FOOTER //
// ./src/store/actions/upload.js